export const customerTypes = [
    {value: "REGIONAL_ROADS", label: "Минтақавий йўлларга буюртмачи"},
    {value: "SINGLE_CUSTOMER", label: "Ягона буюртмачи"},
    {value: "ELECTRICITY_SUPPLY", label: "Электр энергия таъминоти"},
    {value: "PRESCHOOL_AND_SCHOOL", label: "Мактабгача ва мактаб бўлимлари"},
    {value: "AREA_GAS", label: "Ҳудудгаз"},
    {value: "MEDICAL_ASSOCIATION", label: "Тиббиёт бирлашмалари"},
    {value: "WATER_CONSTRUCTION", label: "Сув қурилиш таъминотчиси"},
    {value: "LANDSCAPING_DEPARTMENTS", label: "Ободонлаштириш бўлимлари"},
    {value: "GOVERNORS", label: "Ҳокимликлар"},
    {value: "ECOLOGY", label: "Экология бошқармалари"},
    {value: "OTHERS", label: "Бошқалар"}
];
export const customerTypesObject = {
    REGIONAL_ROADS: "Минтақавий йўлларга буюртмачи",
    SINGLE_CUSTOMER: "Ягона буюртмачи",
    ELECTRICITY_SUPPLY: "Электр энергия таъминоти",
    PRESCHOOL_AND_SCHOOL: "Мактабгача ва мактаб бўлимлари",
    AREA_GAS: "Ҳудудгаз",
    MEDICAL_ASSOCIATION: "Тиббиёт бирлашмалари",
    WATER_CONSTRUCTION: "Сув қурилиш таъминотчиси",
    LANDSCAPING_DEPARTMENTS: "Ободонлаштириш бўлимлари",
    GOVERNORS: "Ҳокимликлар",
    OTHERS: "Бошқалар"
}
